import React from 'react';
import API from '../../../../utils/API';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField'; // You'll need this for the rename input
import ToggleField from '../../../../components/inputs/toggleField';


class RenameGalleryModal extends React.Component { // Class name should be changed to RenameGalleryModal
    state = {
        submitting: false,
        isGeneralGallery: false,
        newName: '', 
        nameError: false,
        allowPoints: false
        
    };

    componentDidMount() {
        const { galleries, markedGallery } = this.props;
        const gallery = galleries.find(g => g._id === markedGallery);
        if (gallery) {
            this.setState({ newName: gallery.feedName || '', allowPoints: gallery.allowPoints || false   });
        }
    }

    renameGallery = async () => {
        const { eventId, orgId, markedGallery, toggle} = this.props;
        const { newName, allowPoints } = this.state;
        
        if (!newName || newName.trim() === '') {
            this.setState({ nameError: true });
            return;
        }
    
        this.setState({ submitting: true });
    
        try {
            await API().patch(`/Organizations/${orgId}/events/${eventId}/eventFeed/${markedGallery}`, {
                feedName: newName,
                allowPoints: allowPoints
            });
            this.props.renameGallery(markedGallery, newName, allowPoints);
            toggle()

        } catch (err) {
            console.log(err);
            this.setState({ submitting: false });
        }
    };

    handleNameChange = (e) => {
        const newName = e.target.value;
        this.setState({ 
            newName,
            nameError: newName.trim() === '' 
        });
    };

    render() {
        const { isOpen, toggle, } = this.props;
        const { submitting, newName, nameError, allowPoints } = this.state;
        
        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Edit Gallery"}
                    bodyHeaderText={                        
                            <span>Enter a new name for the gallery:</span>
                    }
                    bodyContent={() => {
                        return (
                            <div>
                        
                                <InputField
                                    label="Name"
                                    value={newName}
                                    onChange={this.handleNameChange}
                                    required={true}
                                    errorTrigger={nameError}
                                    errorMessage={"Gallery name cannot be empty"}
                                />
                                <ToggleField label="Allow Points"
                                    checked={allowPoints}
                                    icons={false}
                                    onChange={() => {
                                        this.setState({ allowPoints: !allowPoints })
                                    }} 
                                />
                            </div>
                        )
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Submit' : 'Submitting...'}
                    actionButton={() => this.renameGallery()}
                    actionButtonDisabled={submitting || nameError || !newName}
                ></FieldModal>
            </div>
        );
    }
}

export default RenameGalleryModal; // Export with the correct component name